import React from 'react';
// import { useTranslation } from 'react-i18next';
// import Paper from '@mui/material/Paper';
import Stack from '@mui/material/Stack';

import {
	LinksMetricsWidget,
	MediaAnalysisWidget,
	ProjectsWidget,
	SubscriptionMetricsWidget,
	UploadMediaWidget
} from '../../../../components/DashboardWidgets';

const DashboardContent = (props) => {
	// const { t } = useTranslation('dashboard', { keyPrefix: 'content' });

	return (
		<Stack direction="row" flex={1}>
			<Stack flex={1} margin={1}>
				<UploadMediaWidget />
				<SubscriptionMetricsWidget />
			</Stack>
			<Stack flex={1} margin={1}>
				<MediaAnalysisWidget />
				<ProjectsWidget />
				<LinksMetricsWidget />
			</Stack>
		</Stack>
	);
};

DashboardContent.propTypes = {};

export default DashboardContent;
